import VCard from 'vcard-creator'

export const slugify = (...args: (string | number)[]): string => {
  const value = args.join(' ')

  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/\s+/g, '-')
}

export const shuffle = v => [...v].sort(_ => Math.random() - 0.5).join('')

export const isValidHttpUrl = (str: string): boolean => {
  return /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/.test(str)
}

export const isValidEmail = (email: string): boolean => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const thumbnailify = async (
  base64Image,
  targetSize
): Promise<string> => {
  return new Promise(resolve => {
    const img = new Image()

    img.onload = function () {
      const {width} = img
      const {height} = img
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      // eslint-disable-next-line no-multi-assign
      canvas.width = canvas.height = targetSize

      // @ts-ignore
      ctx.drawImage(
        img,
        width > height ? (width - height) / 2 : 0,
        height > width ? (height - width) / 2 : 0,
        width > height ? height : width,
        width > height ? height : width,
        0,
        0,
        targetSize,
        targetSize
      )

      resolve(canvas.toDataURL('image/jpeg'))
    }

    img.src = base64Image
  })
}

export const convertImgToBase64URL = async url => {
  return new Promise(resolve => {
    const img = new Image()
    img.crossOrigin = 'Anonymous'
    img.onload = function () {
      const canvas = <HTMLCanvasElement>document.createElement('CANVAS')
      const ctx = canvas.getContext('2d')
      canvas.height = img.height
      canvas.width = img.width
      // @ts-ignore
      ctx.drawImage(img, 0, 0)
      const dataURL = canvas.toDataURL('image/jpeg')
      resolve(dataURL)
    }
    img.src = url
  })
}

export const generateVCard = async (userData): Promise<any> => {
  const vCardFile = new VCard()
  vCardFile
    .addName(userData.name)
    .addPhoneNumber(userData.phone)
    .addEmail(userData.email)
    .addNote(userData.bio)
  if (userData.image) {
    const base64Img = await convertImgToBase64URL(userData.image)
    const thumbnail = await thumbnailify(base64Img, 80)
    vCardFile.addPhoto(thumbnail.replace('data:image/jpeg;base64,', ''), 'JPEG')
  }

  if (userData.socialMedia && userData.socialMedia.length) {
    userData.socialMedia.map(item => {
      vCardFile.addURL(item.baseUrl + item.url, item.label)
      return false
    })
  }

  return vCardFile.toString()
}
